import { css } from 'styled-components';
import { media } from './theme';

// Visual padrão dos campos (FormInput, AutoCompleteInput, CampoPesquisa)

export const campoBase = css`
  width: 100%;
  height: 48px;
  padding: 18px 12px 4px 12px;
  border: 1px solid ${({ theme }) => theme.cores.border};
  border-radius: ${({ theme }) => theme.raio.md};
  background-color: ${({ theme }) => theme.cores.card};
  color: ${({ theme }) => theme.cores.ink};
  font-size: ${({ theme }) => theme.fonte.input};
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
  text-overflow: ellipsis;

  &:hover {
    border-color: ${({ theme }) => theme.cores.borderStrong};
  }

  &:focus {
    border-color: ${({ theme }) => theme.cores.primary};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.cores.foco};
  }

  &:read-only {
    background-color: ${({ theme }) => theme.cores.surface};
    color: ${({ theme }) => theme.cores.inkSecondary};
    border-color: ${({ theme }) => theme.cores.border};
    box-shadow: none;
    cursor: default;
  }

  &:user-invalid {
    border-color: ${({ theme }) => theme.cores.critical};
  }

  /* Data: o input date não tem placeholder, o rótulo fica sempre em cima */
  &[type='date'] {
    padding-right: 8px;
  }

  ${media.mobile} {
    /* 16px evita o zoom automático do iOS ao focar */
    font-size: 16px;
  }
`;

// Rótulo que flutua para cima quando o campo tem foco ou valor.
// Requer o input com placeholder=' ' e o rótulo logo depois dele.
export const rotuloFlutuante = css`
  position: absolute;
  left: 13px;
  top: 14px;
  max-width: calc(100% - 26px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.cores.inkMuted};
  font-size: ${({ theme }) => theme.fonte.input};
  pointer-events: none;
  transform-origin: left top;
  transition: transform 0.15s ease, color 0.15s ease;
`;

export const rotuloFlutuanteAtivo = css`
  transform: translateY(-9px) scale(0.78);
  color: ${({ theme }) => theme.cores.inkSecondary};
  font-weight: 500;
`;
